import {Component, OnInit} from '@angular/core';
import {User, UserService} from '../../core';
import {Router} from '@angular/router';
import {Location} from '@angular/common';
import {TitleInfo, TitleService} from '@common-lib';
import {environment} from "environments/environment";
import { rootRenderNodes } from '@angular/core/src/view';

@Component({
  selector: 'app-layout-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  title = 'Dashboard';
  titleParams: any = {};
  currentUser: User;
  showPluginMenu : boolean = false;
  roles = [];

  menus = {
    'admin': ['pages', 'media', 'configuration', 'settings', 'settings-translations', 'settings-users', 'settings-permissions',
              'settings-markets', 'settings-policies', 'settings-product-settings', 'products-group', 'products', 'navigation',
              'categories', 'subcategories', 'views', 'variant-groups', 'variants', 'settings-group'],
    'user': ['pages', 'media', 'configuration', 'settings', 'settings-translations',
              'settings-markets', 'settings-policies', 'settings-product-settings', 'products-group', 'products', 'navigation',
              'categories', 'subcategories', 'views', 'variant-groups', 'variants', 'settings-group'],
    'manager': ['pages', 'media', 'configuration', 'settings', 'settings-translations',
                'settings-markets', 'settings-policies', 'settings-product-settings', 'products-group', 'products', 'navigation',
                'categories', 'subcategories', 'views', 'variant-groups', 'variants', 'settings-group'],
  };

  constructor(private router: Router,
              private location: Location,
              private userService: UserService,
              private titleService: TitleService,
  ) {
  }

  ngOnInit() {
    this.initUser();
    this.titleService.title.subscribe((titleInfo: TitleInfo) => {
      this.title = titleInfo.title;
      this.titleParams = titleInfo.params;
    });

    this.showPluginMenu = environment.plugin_gotenehus_on;
  }

  checkPermission(menuItem) {
    let res = false;
    this.roles.forEach((role) => {
        if(this.menus[role].includes(menuItem)) {
          res = true;
        }
    });
    return res;
  }

  initUser() {
    this.userService.currentUser.subscribe((userData) => {
      this.currentUser = userData;
      if(this.currentUser.roles) {
        this.roles = (this.currentUser.roles as string).split(',');
      }
    });
  }

  logout(e) {
    e.preventDefault();
    this.userService.purgeAuth();
    this.router.navigate(['/login']);
  }

  navigateTo(url, event) {
    event.preventDefault();
    this.router.navigate([url]);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/layout/header.component.ts